/* jshint esversion: 6 */
import React from 'react';
import MediaEditorButton from 'app/components/PostingTool/MediaEditorButton.jsx';
import EmblaCarousel from 'app/components/common/EmblaCarousel.jsx';
import MediaUploader from 'app/components/PostingTool/MediaUploader.js';
import ErrorThumbnail from 'app/components/PostingTool/Accessories/ErrorThumbnail.jsx';

class ThumbnailPreview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: 'mb_id',
            imagesToLoad: [],
            initialized: false
        };

        this.updateLoadStatus = this.updateLoadStatus.bind(this);
        this.removeImage = this.removeImage.bind(this);

    }

    static getDerivedStateFromProps(props, state) {

        if (!state.initialized) {
            if (props.imageLink !== undefined && props.imageLink && !state.initialized) {
                return {
                    mode: 'link',
                    imagesToLoad: [
                        {
                            thumb: props.imageLink,
                            type: null,
                            isLoaded: false,
                            isLink: true
                        }
                    ],
                    initialized: true
                };
            } else if (props.mediaThumbs.length && (props.mb_id !== undefined && props.mb_id || props.hashes !== undefined && props.hashes.length)) {
                let imagesToLoad = [];
                // load images in hash order if the hashes array is present
                // but in an edit case load in mediaThumb order since hashes may not be set up
                if (props.hashes) {
                    for (let i = 0; i < props.hashes.length; ++i) {
                        let media = props.mediaThumbs.find((media) => {return media.hash === props.hashes[i]; });
                        if (media) {
                            imagesToLoad.push({
                                thumb: media.thumb,
                                type: media.type,
                                hash: media.hash,
                                name: media.name,
                                isLoaded: false,
                                isLink: false
                            });
                        }
                    }
                } else {
                    for (let i = 0; i < props.mediaThumbs.length; ++i) {
                        if (props.hashes && props.hashes.length && props.hashes.indexOf(props.mediaThumbs[i].hash) === -1) {
                            continue;
                        }
                        imagesToLoad.push({
                            thumb: props.mediaThumbs[i].thumb,
                            type: props.mediaThumbs[i].type,
                            hash: props.mediaThumbs[i].hash,
                            name: props.mediaThumbs[i].name,
                            isLoaded: false,
                            isLink: false
                        });
                    }
                }

                return {
                    imagesToLoad,
                    initialized: true
                }
            }
        }

        return null;

    }

    componentDidUpdate(prevProps, prevState) {

        let nextImagesToLoad = [],
            imageData = null,
            needsUpdate = false;

        if (prevProps.hashes !== undefined && this.props.hashes !== undefined &&
            prevProps.hashes.length !== this.props.hashes.length ||
            (prevProps.mediaThumbs !== undefined && this.props.mediaThumbs !== undefined &&
             prevProps.mediaThumbs.length !== this.props.mediaThumbs.length)) {
            needsUpdate = true;
        }

        // scan the hash array for order changes to reflect them properly in the thumb carousels
        // also check if an image was edited so the new thumb can be swapped in
        if (prevProps.hashes !== undefined && this.props.hashes !== undefined &&
            prevProps.hashes.length === this.props.hashes.length && this.props.hashes.length >= 1) {
            for (let i = 0; i < prevProps.hashes.length; ++i) {
                if (prevProps.hashes[i] !== this.props.hashes[i] || this.props.hashes.indexOf(prevProps.hashes[i]) === -1) {
                    needsUpdate = true;
                    break;
                }
            }
        }

        if (needsUpdate) {
            if (this.props.hashes) {
                for (let i = 0; i < this.props.hashes.length; ++i) {
                    let media = this.props.mediaThumbs.find((media) => {return media.hash === this.props.hashes[i]; });
                    if (media) {
                        nextImagesToLoad.push({
                            thumb: media.thumb,
                            type: media.type,
                            hash: media.hash,
                            name: media.name,
                            isLoaded: false
                        });
                    }
                }
                this.setState({
                    imagesToLoad: nextImagesToLoad
                })
            }  else {
                for (let i = 0; i < this.props.mediaThumbs.length; ++i) {
                    imageData = nextImagesToLoad.find((image) => { return image.hash === this.props.mediaThumbs[i].hash; });
                    nextImagesToLoad.push({
                        thumb: this.props.mediaThumbs[i].thumb,
                        type: this.props.mediaThumbs[i].type,
                        hash: this.props.mediaThumbs[i].hash,
                        name: this.props.mediaThumbs[i].name,
                        isLoaded: false
                    });
                    this.setState({
                        imagesToLoad: nextImagesToLoad
                    });
                }
            }
        }

    }

    updateLoadStatus(image) {
        let nextImagesToLoad = [...this.state.imagesToLoad];

        for (let i = 0; i < nextImagesToLoad.length; ++i) {
            if (image.thumb === nextImagesToLoad[i].thumb) {
                nextImagesToLoad.isLoaded = true;
                break;
            }
        }

        this.setState({
            imagesToLoad: nextImagesToLoad
        })
    }

    removeImage(e) {
        let fieldPath = (this.props.editMode === 'shared') ? `postData.shared.imageLink` : `postData.services.${this.props.serviceType}.imageLink`,
            postChange = {
                currentTarget: {
                    dataset: {
                        field: fieldPath
                    }
                },
                target: {
                    'value': ''
                }
            },
            hash = (e.currentTarget.dataset.hash !== undefined && e.currentTarget.dataset.hash) ? e.currentTarget.dataset.hash : null,
            removeImageData = (hash) => {
                let nextImagesToLoad = [];

                this.props.removeThumb(hash, this.props.serviceType);

                for (let i = 0; i < this.state.imagesToLoad.length; ++i) {
                    if (this.state.imagesToLoad[i].hash !== hash) {
                        nextImagesToLoad.push(this.state.imagesToLoad[i]);
                    }
                }

                this.setState({
                    imagesToLoad: nextImagesToLoad
                });
            };

        if (hash && this.props.mb_id !== undefined && this.props.mb_id > 0) {
            let formData = new FormData;
            formData.append('mb_id', this.props.mb_id);
            formData.append('action', 'remove');
            formData.append('hash', hash);
            formData.append('type', 'postMedia');

            MediaUploader({
                context: this,
                formData,
                onUploadProgress: (progress) => {},
                responseCallback: (response) => {
                    removeImageData(hash);
                },
                errorCallback: (error) => {
                    if (error.response) {
                        let errorData = error.response.data.errors || null,
                            errorMsgs = [];

                        const extractErrors = (obj) => {
                            if (Object.keys(obj).length) {
                                Object.keys(obj).map((key) => {
                                    if (typeof obj[key] === 'string') {
                                        errorMsgs.push(obj[key]);
                                    } else if (Object.keys(obj[key])) {
                                        extractErrors(obj[key]);
                                    }
                                });
                            }
                        };

                        // session died before upload
                        if (error.response.status === 403) {
                            window.location.reload();
                            return;
                        }

                        extractErrors(errorData);

                        if (errorMsgs.length) {
                            this.setState({
                                errors: errorMsgs.join(" ")
                            });
                        }
                    }
                }
            });

        } else {
            if (hash && this.props.hashes !== undefined) {
                removeImageData(hash);
            } else {
                this.props.requestChange(postChange);
            }

        }

    }

    render() {
        let thumbnailClass = `preview-image ${this.props.editMode}`;

        if (this.props.editMode === 'shared') {
            thumbnailClass = 'shared-carousel';
        } else if (this.props.editMode === 'network' && this.state.imagesToLoad.length > 1) {
            thumbnailClass += ' multi';

        }

        if (!this.state.initialized) {
            return null;
        }

        return (
            <div className={thumbnailClass}>
                <EmblaCarousel options={{
                            container: ".carousel-slide-wrapper",
                            slide: ".carousel-slide",
                            align: 'start',
                            loop: true
                        }}
                        extraClasses={'thumbnails'}
                        mode={this.props.editMode}>
                    {this.state.imagesToLoad.map((image) => {
                        let editorButton = null,
                            removePreview = null;

                        if (!image.isLink) {
                            editorButton = (
                                <MediaEditorButton
                                    {...this.props}
                                    fileType={image.type}
                                    hash={image.hash}/>
                            );
                        }

                        if (!image.isLoading) {
                            if (image.hash) {
                                removePreview = (
                                    <div className="remove-preview" role="button" aria-label="Remove Image" onClick={this.removeImage} data-hash={image.hash}>
                                        <i className="fa fa-times-circle"></i>
                                    </div>
                                );
                            } else {
                                removePreview = (
                                    <div className="remove-preview" role="button" aria-label="Remove Image" onClick={this.removeImage}>
                                        <i className="fa fa-times-circle"></i>
                                    </div>
                                );
                            }

                        }

                        let imageElement = null;

                        let mediaErrors = this.props.mediaHashHasErrors(image.hash, this.props.serviceType);
                        if (mediaErrors.length) {
                            let extraClasses = '';
                            if (this.props.editMode === 'shared') {
                                extraClasses = 'shared';
                            }
                            imageElement = (
                                <ErrorThumbnail
                                    hash={image.hash}
                                    errorThumb={image}
                                    file={image.name}
                                    error={mediaErrors}
                                    extraClasses={extraClasses}/>
                            );
                        } else {
                            imageElement = (
                                <img src={image.thumb} style={{
                                    display: (image.isLoading) ? 'none' : 'block'
                                }} onLoad={(e) => { this.updateLoadStatus(image); }}/>
                            );
                        }

                        let key = (!image.isLink) ? image.hash : image.thumb;

                        return (
                            <div key={key} className={`carousel-slide ${this.props.editMode}`}>
                                <div className="slide-wrapper">
                                    {removePreview}
                                    {editorButton}
                                    <div className="image-wrapper">
                                        {imageElement}
                                        {image.isLoading ? (
                                            <div className="working">
                                                <i className="fa fa-circle-o-notch fa-spin"></i>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </EmblaCarousel>

            </div>
        );
    }
}

ThumbnailPreview.displayName = "ThumbnailPreview";

export default ThumbnailPreview;
